import { useEffect, useState } from 'react'
import { chainConfig } from '../config'
import { WalletProvider } from '../graphql/variables/WalletVariable'
import { walletService } from '../services/WalletService'
import { BoxAsset } from '../types/BoxTypes'
import { WalletERC20Share } from '../types/WalletTypes'
import { useGlobalConfig } from './ConfigHook'

/**
 * @deprecated need move WalletProvider.theGraph to backendV2
 *
 */
export function useProfileFractions(account: string, chainId: number) {
  const [fractions, setFractions] = useState<WalletERC20Share[]>([])
  const config = chainConfig(chainId)
  const { paginationLimit } = useGlobalConfig()
  const [loading, setLoading] = useState<boolean>(true)
  const [hasMore, setHasMore] = useState<boolean>(true)
  const [offset, setOffset] = useState<number>(0)
  const boxAddress = config?.box.contract

  useEffect(() => {
    const getErc20Fractions = async () => {
      if (account) {
        setLoading(true)
        setHasMore(true)
        setFractions([])
        const nftsV2 = await walletService(WalletProvider.theGraph).getERC20Shares(account, chainId, 2)

        const nftItemsBox: BoxAsset[] = []
        const erc20ShareListHandleBox: WalletERC20Share[] = []
        nftsV2.forEach(share => {
          const nftBoxItem = nftItemsBox.find(
            nftBox =>
              share.target.collection?.id.toLowerCase() === boxAddress?.toLowerCase() && share.target.tokenId === nftBox.boxId.toString()
          )
          if (nftBoxItem) {
            const newNftItem = { ...share, nftsCount: nftBoxItem.nftCount }
            erc20ShareListHandleBox.push(newNftItem)
          } else {
            erc20ShareListHandleBox.push(share)
          }
        })

        const erc20Fractions = erc20ShareListHandleBox.map(share => ({ ...share, chainId }))

        setFractions(erc20Fractions)
        setOffset(erc20Fractions.length)
        setLoading(false)

        if (erc20ShareListHandleBox.length < paginationLimit) {
          setHasMore(false)
        }
      } else {
        setLoading(false)
        setHasMore(false)
      }
    }
    getErc20Fractions()
  }, [account, boxAddress, chainId, paginationLimit])

  const loadMore = async () => {
    if (account) {
      const nftsV2 = await walletService(WalletProvider.theGraph).getERC20Shares(account, chainId, 2, offset)

      const nftItemsBox: BoxAsset[] = []
      const erc20ShareListHandleBox: WalletERC20Share[] = []
      nftsV2.forEach(share => {
        const nftBoxItem = nftItemsBox.find(
          nftBox =>
            share.target.collection?.id.toLowerCase() === boxAddress?.toLowerCase() && share.target.tokenId === nftBox.boxId.toString()
        )
        if (nftBoxItem) {
          const newNftItem = { ...share, nftsCount: nftBoxItem.nftCount }
          erc20ShareListHandleBox.push(newNftItem)
        } else {
          erc20ShareListHandleBox.push(share)
        }
      })

      const items = fractions.concat(erc20ShareListHandleBox)

      setFractions(items)
      setOffset(items.length)

      if (erc20ShareListHandleBox.length < paginationLimit) {
        setHasMore(false)
      }
    } else {
      setLoading(false)
      setHasMore(false)
    }
  }
  return { fractions, loading, hasMore, loadMore }
}
